interface DurationOptionsProps {
  options: {
    allowFullDay: boolean;
    allowHalfDay: boolean;
    allowMonth: boolean;
  };
  onChange: (key: string, value: boolean) => void;
}

export function DurationOptions({ options, onChange }: DurationOptionsProps) {
  return (
    <div>
      <h4 style={{ fontSize: '0.95rem', fontWeight: 600, color: '#00303c', marginBottom: '1rem' }}>Options de durée</h4>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        <CheckboxOption
          label="Journée complète autorisée"
          checked={options.allowFullDay}
          onChange={(v: boolean) => onChange('allowFullDay', v)}
        />
        <CheckboxOption
          label="Demi-journée autorisée"
          checked={options.allowHalfDay}
          onChange={(v: boolean) => onChange('allowHalfDay', v)}
        />
        <CheckboxOption
          label="Mois autorisé"
          checked={options.allowMonth}
          onChange={(v: boolean) => onChange('allowMonth', v)}
        />
      </div>
    </div>
  );
}

interface CheckboxOptionProps {
  label: string;
  checked: boolean;
  onChange: (value: boolean) => void;
}

function CheckboxOption({ label, checked, onChange }: CheckboxOptionProps) {
  return (
    <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        style={{ width: '18px', height: '18px', accentColor: '#00758d' }}
      />
      <span style={{ fontSize: '0.9rem', color: '#00303c', fontWeight: 500 }}>{label}</span>
    </label>
  );
}
